import * as React from 'react';
import { Descriptions } from 'antd';
import cx from 'classnames';
import keyValueDisplayCss from './key-value-display.css';
import { Breakpoint } from 'antd/lib/_util/responsiveObserve';

export interface IKeyValueDisplayItem {
    title: string;
    className?: string;
    style?: React.CSSProperties;
    content: React.ReactNode;
    span?: number;
}

export interface IKeyValueDisplayProps {
    title?: string;
    items: IKeyValueDisplayItem[];
    column?: number | Partial<Record<Breakpoint, number>>;
    bodered?: boolean;
    layout?: 'horizontal' | 'vertical';
}

export function KeyValueDisplay(props: IKeyValueDisplayProps) {
    return (
        <Descriptions
            bordered={props.bodered}
            title={props.title}
            size='small'
            className={keyValueDisplayCss.keyValueDisplay}
            column={props.column ?? 1}
            layout={props.layout}
        >
            {props.items.map((item) => (
                <Descriptions.Item key={item.title} label={item.title} style={item.style} span={item.span} className={cx(keyValueDisplayCss.item, item.className)}>
                    {item.content}
                </Descriptions.Item>
            ))}
        </Descriptions>
    );
}
